import { autoCompleteConfig } from '../constants/addressAutoComplete';

export function extractAddressComponent (arr, prop) {
  const matches = arr.filter(({ types }) => types.includes(prop));
  if (!matches.length) return '';
  const { state } = autoCompleteConfig;
  if (prop === state) {
    return matches[0]['short_name'];
  }
  return matches[0]['long_name'];
}

export const convertCoordsWKT = (lat, lng) =>
  `POINT(${lng} ${lat})`;



// WEBPACK FOOTER //
// ./src/helpers/addressAutoComplete.js